// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/static/css/async/" + chunkId + "." + {"2890": "e8e72c82","3624": "fad749dc","859": "29dbaee5",}[chunkId] + ".css"
}